import { useCallback, useState } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "./InlineDatePicker.css";

interface InlineDatePickerProps {
  onChange?: (dates: [Date | null, Date | null]) => void;
  startDate?: Date | null;
  endDate?: Date | null;
}

const formatWeekDay = (name: string) => {
  return name.charAt(0);
};

const InlineDatePicker = ({
  onChange,
  startDate,
  endDate,
}: InlineDatePickerProps) => {
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    startDate ?? null,
    endDate ?? null,
  ]);

  const handleDateChange = useCallback(
    (dates: [Date | null, Date | null]) => {
      const [start, end] = dates;

      if (start && end) {
        const diffTime = Math.abs(end.getTime() - start.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 31) {
          const newEndDate = new Date(start);
          newEndDate.setDate(start.getDate() + 31);
          dates = [start, newEndDate];
        }
      }

      setDateRange(dates);
      onChange?.(dates);
    },
    [onChange],
  );

  const today = new Date();
  const twoYearsFromNow = new Date();
  twoYearsFromNow.setFullYear(today.getFullYear() + 2);

  return (
    <DatePicker
      selectsRange
      startDate={dateRange[0]}
      endDate={dateRange[1]}
      onChange={handleDateChange}
      inline
      formatWeekDay={formatWeekDay}
      minDate={today}
      maxDate={twoYearsFromNow}
    />
  );
};

export { InlineDatePicker };
